// src/constants/routes.js
export const ROUTES = {
  REGISTRATION: "/registration",
  DASHBOARD: "/dashboard",
  REMOTE: "/remote",
  HOME: "/",
  ADMINDASHBOARD: '/admin-dashboard',
  EMPLOYEEATTENDANCE: '/mark-employee-attendance',
  STUDENTTABLE: "/table",
  STUDENTATTENDANCE: "/student-attendance",
  CLASS: "/class-create",
  EMPLOYEEATTENDANCEREPORT: "/employee-attendance-report",
  ADMISSIONREPORT: "/reports-admission-report",
  // STAFF_ADD: "/staff-add",
  STAFFADDFORM: "/add-staff",
  ASSIGNSUBJECTS: "/assign-subjects",
  DESIGNATIONROLE: "/designation-master",
  BULKSTUDENT: "/bulk-student",
  TIMEPERIODMASTER: "/time-period",
   ROUTEMANAGEMENT: "/route-management",
   VEHICLEMANAGEMENT: "/vehicle-management",
   STUDENTTRANSPORTALLOCATION: "/student-transport-allocation",
  STAFF_MANAGE: "/staff-manage",
  ASSIGNMENUROLE: "/assign-menu",
  ASSIGNUSERROLE: "/users-assign-roles",
  LEADERSTUDENTWISE: "/ledger-student-wise",
  USERACCES: "/user-access",
  STAFF_LOGIN: "/staff-login",
  SIDEBARCONFIGURATION: "/sidebar-configuration",
  ADDSTUDENT: '/add-student',
  STUDENTDOCUMENT: '/students-document',
  PROMOTESTUDENT: '/transfer-student',
  SYSTEMSETUPSCHOOL: '/initial-system-setup',
  TRIALENDED: '/trial-ended',
  EDITSTUDENT: '/view-student',
  STUDENTREPORT: '/student-report',
  ALLCOMPONENTS: '/all-components',
  STUDENTSIGNIN: '/student-login',
  FORGOTPASSWORD: '/student-forgot-password',
  PROFILEPAGE: '/profile',
  AUDITLOG: '/audit-log',
  TWOAUTHENTICATION: '/two-step-authentication',
  PARENTSIGNIN: '/parent-login',
  EMPLOYEESIGNIN: '/employee-login',
  ADMINSIGNIN: '/admin-login',
  ADMINFORGOTPASSWORD: '/admin-forgot-password',
  EMPLOYEEFORGOTPASSWORD: '/employee-forgot-password',
  PARENTFORGOTPASSWORD: '/parent-forgot-password',
  CLASSTIMETABLE: '/timetable-create',
  TIMETABLE: '/timetable-edit',
  // MANAGECLASSES: '/add-classes',
  MASTER: "/master",
  SUBJECTMAPPING: "/subject-mapping",
  STUDENTPROFILE: '/student-profile',
  STAFFPROFILE: '/staff-profile',
  VIEWTIMETABLE: '/timetable-view',
  SCHOOLPROFILE: '/school-profile',
  STUDENTATTENDENCEREPORT: '/student-attendance-report',
  TEACHERDASHBOARD: '/teacher-dashboard',
  COMMUNICATIONPANEL: '/send-sms-email',
  CHAT: '/chat',
  NOTICEBOARDPANEL: '/notice-board',
  TEACHERLEAVE:'/my-leave',
  LEAVEAPPROVIDEREQUEST:'/leave-approved-request',
  MASTERLEAVEFORM:'/leave-master',
  CREATENEWEXAM:'/create-new-exam',
  STUDENTEXAMTIMTABLE:'/exam-timetable',
  STUDENTMARKSHEET:'/exam-result',
  EXAMSCHEDULETABLE:'/exam-schedule',
  RESULTREPORT:'/result-report',
  EXAMADDUPDATETABLE:'/add-update-exam-marks',
  BULKEXAMADDUPDATETABLE:'/bulk-update-exam-mark',
  BULKATTENDANCEUPDATE:'/bulk-attendance-update',
  CREATETICKET: '/create-ticket',
  REMOTESUPPORT: '/remote-support',
  SETUPPAGE: '/setup',
  STUDENTDASHBOARD: '/student-dashboard',
  ONBOARDING: '/on-boarding',
  THEMESETTINGPAGE: '/theme-setting',
  FEEMASTER: '/fee-master',
  ASSIGNFEE: '/Assign-Fees-to-Classes',
  COLLECTFEE: '/collect-fee',
  FEEREMINDER: '/fee-reminder',
  EMPLOYEESTUDENTATTENDENCE: "/mark-student-attendance",
  EMPLOYEESTUDENTATTENDANCEREPORT: "/student-attendance-report",
  CLASSTEACHER: '/add-Class-teacher',
  ADDHOMEWORK:'/add-homework',
  HOMEWORKEVALUATION:'/homework-evaluation',
  HOMEWORKREPORT:'/homework-report',
  STUDENTHOMEWORK:'/student-homework',
  HOLIDAYS:'/holidays',
  PARENTDASHBOARD:'/parent-dashboard',
  
  MARKEMPLOYEEATTENDENCE: "/mark-employee-attendance",
  REPORTEMPLOYEEATTENDENCE: "/employee-attendance-report",
  EMPLOYEEDASHBOARD:'/employee-dashboard',
  MYATTENDANCEREPORT:'/my-attendance-report',
  BULKDATAUPLOAD:'/bulk-uploads',
  PRIVACYPOLICY:'/privacy-notice',
  TERMS:'/terms',

  GENERATCERTIFICATE:'/generate-certificate',

  GENERATEIDCARD:'/generate-id-card',
  EXAMMASTER:'/marks-grading',
  STOPMANAGEMENT:'/stop-management',
  IDCARD:'/id-card-template',
  TCREPORT:'/tc-report',
  FEESREPORT:'/fees-report',
  CLASSFEESREPORT:'/class-wise-fee-report',
  
  HOSTMEETING:'/host-meeting',
  GATEPASS:'/exit-gate-master',
  VISITPASS:'/visit-types',
  GATEPASSlIST:'/gate-pass-list',
  FEEDUEREPORT:'/fee-due-report',
  FEECOLLECTIONREPORT:'/fee-collection-report',
  FINACESUMMARY:'/finance-summary',
  PETTYCASH:'/petty-cash',
  REPORTS:'/reports',
  PETTYLEDGER:'/cash-ledger',
  PETTYCLOSING:'/cash-closing',
  DISCOUNTREPORT:'/discount-report',
  STUDENTFEEDUEREPORT:'/fee-due-report-details',
  STUDENTFEECOLLECTIONREPORT:'/fee-collection-report-details',
  DISCOUNTDETAILS:'/discount-details',
  STUDENTADDMISSIONSETTING:'/admission-form-settings',
  INQSTATUSMASTER:'/status-master',
  ADDINQUIRY:'/add-inquiry',
  INQUIRYDETAILPAGE:'/inquiry-details',
  WHASAPPSETTING:'/whatsapp-setting',
  PAYMENTGATEWAYPAGE:'/payment-setting',
  BIOMETRICREGISTRATION:'/biometric-device-registration',
  OFFLINEFEEVERIFICATION:'/offline-fee-varification',
  MARKSHEETSAMPLE:'/Marksheet-sample',
  PARENTKIDFEES:'/fees',
  STUDENTFEEASSIGN:'/student-fee-structure',
  CREATEHOSTEL: '/create-hostel',
  ADDROOMTYPE: '/add-room-type',
  ADDHOSTELROOM: '/add-hostel-room',
  STUDENTHOSTELALLOCATION: '/assign-hostel',
  GENERATEADMITCARD:'/admit-card',
  CREATEADMITCARD:'/create-exam-timetable',
  GENERATEADMITCARDNEW:'/generate-admit-card',
  EXAMPUBLISH:'/exam-publish',
  COLLECTFEENEW:'/collect',
  COLLECTFEEDETAILSNEW:'/collect-fee-details',
  TRANSPORTFEE:'/trasnport-fee',
  ADDSUBJECT:'/add-subject',
  SCHOOLANALYTICS:'/school-analytics',
  COLSCHOLASTICEXAM:'/co-scholastic-marks-entry-edit',
  ASSIGNADDITIONALSUBJECT:'/assign-additional-subject',
  SESSIONSETTING:'/session-setting',
  MARKSHEETS:'/marksheets',
  CUSTOMTIMETABLE:'/custom-timetable',
  PROMOTESTUDENTNEW:'/promote-student',
  EXAMMAPPING: '/exam-mapping',
  EXAMSUBJECTSANALYTICS: '/exam-subjects-analytics',
  ADDINSTITUTE:'/add-institute',
  HOSTELMASTER:"/hostel-Master",
  HOSTELFEE:"/add-hostel-fees",
  MANAGELOGINS:"/manage-logins",
  VEHICLETRACKING:'/vehicle-tracking',
  //VEHICLETRACKINGHISTORY:'/vehicle-tracking-history',
  EXPENSE:"/expense-details",
  EXPENSEMASTER:"/expense-master",
  VEHICLETRACKINGHISTORYMAP:'/vehicle-tracking-history',
  GENERATETC:'/generate-tc',
  ADDDUE:'/add-due',
  CERTIFICATEMASTER:'/certificate-master',
  CREATECERTIFICATE:'/create-certificate',
  RECEIPTSDOWNLOAD:'/receipts-download',
  MOVESTUDENTLIST:'/student-move-report',

  SYLLABUSMASTER: '/syllabus-master',
  SYLLABUSDETAILS: '/syllabus-details',
  STUDENTSYLLABUS: '/student-syllabus',

  PAYROLLMASTER:"/pay-roll-master",
  PAYSLIP:"/paySlips",
  PAYSLIPRUN:"/payroll-history",
  BULKATTENDANCE:"/bulk-staffAttendance-update",
  ADVANCESALARY:"/advance-salary-management",
  HOUSEMASTER:"/house",
  HOUSEVIEWDETAIL:"/view-house-details",
  EMPLOYEEPUNCHINOUTREPORT:"/employee-punch-report",
  ISSUEDCERTIFICATE:"/issue-certificate",
  BULKEXAMMARKSUPLOAD:"/bulk-exam-marks-upload",
  MARKSHEETSETTING: "/marksheet-setting",
};

export const ROLES = {
  ADMIN: "admin",
  EMPLOYEE: "employee",
  TEACHER: "teacher",
  PARENT: "parent",
  STUDENT: "student",
  DIRECTOR: "director",
  SUPERDIRECTOR: "superdirector",
};
